import { BiMinus, BiPlus } from 'react-icons/bi'
import { Fragment, useState } from 'react'
import { Answer, Question } from './faq-styles'
import { qAndAs } from './faq-types'

const QuestionAndAns = ({ answer, question }: qAndAs) => {
  const [open, setOpen] = useState(false)
  const toggle = () => {
    setOpen(!open)
  }

  return (
    <Fragment>
      <Question data-testid="question" onClick={toggle}>
        {question}
        <div>{open ? <BiMinus data-testid="minus" /> : <BiPlus data-testid="plus" />}</div>
      </Question>
      {open && <Answer data-testid="answer">{answer}</Answer>}
    </Fragment>
  )
}

export default QuestionAndAns
